// import region ,react
import React, { useState, useMemo, useEffect } from "react";

// custom components
import { Card, CustomSpinner } from "_atoms";
import { PaginationClicker } from "_organisms";
import "./bookings-list.css";

// bootstrap //
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";

// libraries
import { add, format } from "date-fns";
import { useTable } from "react-table";
import {
  Title as TremorTitle,
  Toggle,
  ToggleItem,
} from "@tremor/react";

// services
import { getBookingReviewStatus } from "_services/review-service";
import { PRMCodes } from "_utils/constants";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  selectOrder,
  selectDateToISO,
} from "_redux/slices/prm-bookings/calendar";
import {
  getDepartures,
  departureList,
  selectDepartureStatus,
  selectDepartureSkip,
  getDeparturesCount,
  getDeparturesWithSearch,
} from "_redux/slices/prm-bookings/departures";
import {
  getArrivals,
  selectArrivalStatus,
  getArrivalsCount,
  getArrivalsWithSearch,
  selectArrivalsSkip,
} from "_redux/slices/prm-bookings/arrivals";
import * as arrivalsSlice from "_redux/slices/prm-bookings/arrivals";
import { selectUserDb } from "_redux/slices/main-screen/user";
import { selectIata } from "_redux/slices/main-screen/user";
import { selectAirlineSelectedAirport } from "_redux/slices/prm-bookings/bookings";
import {
  selectBookingTableType,
  setTable,
} from "_redux/slices/prm-bookings/bookings-table";
import {
  selectAnalyticsTypeSelector,
  getArrivalsForecast,
  getArrivalsCountForecast,
  getDeparturesCountForecast,
  getDeparturesForecast,
  getAnalyticsCountInboundByHourForForecast,
  getAnalyticsCountOutboundByHourForForecast,
} from "_redux/slices/prm-bookings/bookings-count";

//end region
const BookingsList = () => {
  function getBookings() {
    if (search) {
      dispatch(
        getDeparturesWithSearch(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: departureSkip,
            search: search,
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );
      // get arrivals
      dispatch(
        getArrivalsWithSearch(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: arrivalSkip,
            search: search,
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );
    } else {
      // get bookings count
      dispatch(
        getDeparturesCount(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: 1000,
            skip: 0,
            search: "",
            carrierCode: filter,
            order: order,
            type: "outbound",
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );
      dispatch(
        getArrivalsCount(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: 1000,
            skip: 0,
            search: "",
            carrierCode: filter,
            order: order,
            type: "inbound",
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );
      // get bookings
      dispatch(
        getDepartures(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: departureSkip,
            search: "",
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );
      // get arrivals
      dispatch(
        getArrivals(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: arrivalSkip,
            search: "",
            order: order,
            carrierCode: filter,
            source: analyticsTypeSelector,
          },
          controller.signal
        )
      );

      // only get forecast if not connect bookings filter
      if (analyticsTypeSelector == "C" || dbUser.details.type === "AIRLINE") {
      } else {
        // get forecast
        dispatch(
          getDeparturesCountForecast(
            {
              iata: dbUser.details.type != "AIRLINE" ? iata : airport,
              start: date,
              end: date,
              limit: 1000,
              skip: 0,
              search: "",
              carrierCode: filter,
              order: order,
              type: "outbound",
              source: analyticsTypeSelector,
              forecast: true,
            },
            controller.signal
          )
        );
        dispatch(
          getArrivalsCountForecast(
            {
              iata: dbUser.details.type != "AIRLINE" ? iata : airport,
              start: date,
              end: date,
              limit: 1000,
              skip: 0,
              search: "",
              carrierCode: filter,
              order: order,
              type: "inbound",
              source: analyticsTypeSelector,
              forecast: true,
            },
            controller.signal
          )
        );
        // get bookings
        dispatch(
          getDeparturesForecast(
            {
              iata: dbUser.details.type != "AIRLINE" ? iata : airport,
              start: date,
              end: date,
              limit: 1000,
              skip: departureSkip,
              search: "",
              order: order,
              carrierCode: filter,
              source: analyticsTypeSelector,
              forecast: true,
            },
            controller.signal
          )
        );
        // get arrivals
        dispatch(
          getArrivalsForecast(
            {
              iata: dbUser.details.type != "AIRLINE" ? iata : airport,
              start: date,
              end: date,
              limit: 1000,
              skip: arrivalSkip,
              search: "",
              order: order,
              carrierCode: filter,
              source: analyticsTypeSelector,
              forecast: true,
            },
            controller.signal
          )
        );
      }
    }
  }

  // get daily bookings for csv file
  const getCSVData = () => {
    let countParams = {
      iata: dbUser.details.type == "AIRLINE" ? airport : iata,
      date: date,
      endDate: add(new Date(date), { days: 0 }).toISOString().split("T")[0],
      source: analyticsTypeSelector,
      airline:
        dbUser.details.type == "AIRLINE" ? dbUser.details.authority : null,
      byFlight: true,
    };
    if (dbUser.details.type !== "AIRLINE") {
      dispatch(getAnalyticsCountInboundByHourForForecast(countParams));
      dispatch(getAnalyticsCountOutboundByHourForForecast(countParams));
    }
  };

  //#region state + redux
  // state
  const dbUser = useSelector(selectUserDb);
  const limit = 100;

  // redux variables
  const dispatch = useDispatch();
  const date = useSelector(selectDateToISO); // selected date from calendar

  const analyticsTypeSelector = useSelector(selectAnalyticsTypeSelector); // 'source' (app/sita/portal) or 'none' (all bookings)

  // arrivals
  const arrivals = useSelector(arrivalsSlice.arrivalsList());
  const arrivalSkip = useSelector(selectArrivalsSkip);

  // departures
  const departures = useSelector(departureList());
  const departureSkip = useSelector(selectDepartureSkip);

  // table
  const type = useSelector(selectBookingTableType);
  const airport = useSelector(selectAirlineSelectedAirport);
  const order = useSelector(selectOrder);

  const controller = new AbortController();
  const iata = useSelector(selectIata);
  const [filter, setFilter] = useState(
    dbUser.details.type == "AIRLINE" ? iata : ""
  );
  //#endregion

  // loading
  const departureStatus = useSelector(selectDepartureStatus); // status of fetching bookings
  const arrivalStatus = useSelector(selectArrivalStatus); // status of fetching bookings
  const [search, setSearch] = useState("");

  // get list and count
  useEffect(() => {
    // if user exsists 
    if (dbUser) {
      getBookings();
      getCSVData();
    }
  }, [airport, date, analyticsTypeSelector]);

  //#region review status
  const isAirline = dbUser.details.type === "AIRLINE";
  const hereCode = isAirline ? airport : iata; // airline accounts pick an airport
  const rows = type == "Departures" ? departures : arrivals;
  const rowIds = rows.map((r) => r.id).join(",");
  const [reviewStatus, setReviewStatus] = useState({});

  // fetch review status for the rows on screen (airline accounts can't read airport reviews)
  useEffect(() => {
    if (isAirline || !rows.length) return;
    let cancelled = false;
    getBookingReviewStatus({
      iata,
      bookings: rows
        .filter((r) => r.id)
        .map((r) => ({
          bookingId: r.id,
          airports: [r.origin, r.destination].filter((a) => a && a.length == 3),
        })),
    })
      .then((result) => !cancelled && setReviewStatus(result))
      .catch(() => !cancelled && setReviewStatus({}));
    return () => { cancelled = true; };
  }, [rowIds, iata, isAirline]);
  //#endregion

  // columns for table
  const columns = useMemo(() => {
    const isDepartures = type == "Departures";
    const formatDay = (value) => {
      const d = value ? new Date(value) : null;
      return d && !isNaN(d.getTime()) ? format(d, "d MMM, HH:mm") : null;
    };

    return [
      {
        Header: "#",
        accessor: "count",
        Cell: ({ value }) => <span className="pbl-index">{value}</span>,
      },
      {
        Header: "Passenger",
        accessor: "name",
        Cell: ({ value }) => <span className="pbl-name">{value}</span>,
      },
      {
        Header: "Flight",
        accessor: "flightNumber",
        Cell: ({ value }) => <span className="pbl-mono">{value || "—"}</span>,
      },
      {
        Header: "Route",
        accessor: "destination",
        Cell: ({ row }) => (
          <span className="pbl-route">
            {row.original.origin || "—"}
            <span>→</span>
            {row.original.destination || "—"}
          </span>
        ),
      },
      {
        Header: isDepartures ? "Departs" : "Arrives",
        accessor: isDepartures ? "departureTime" : "arrivalTime",
        Cell: ({ value }) => <span className="pbl-mono">{value}</span>,
      },
      {
        Header: "Due",
        accessor: "dueTime",
        Cell: ({ value }) =>
          !value || value == "N/A" || value == "Not Available"
            ? <span className="pbl-muted">—</span>
            : <span className="pbl-mono">{value}</span>,
      },
      {
        Header: "Assistance",
        accessor: "assistances",
        Cell: ({ value }) => {
          const codes = (value || []).filter((a) => PRMCodes.includes(a));
          return codes.length ? (
            <div className="pbl-codes">
              {codes.map((code) => <span key={code} className="pbl-code">{code}</span>)}
            </div>
          ) : <span className="pbl-muted">—</span>;
        },
      },
      {
        Header: "Equipment",
        accessor: "equipment",
        Cell: ({ value }) => (
          <span className={"pbl-pill " + (value ? "pbl-pill-on" : "pbl-pill-off")}>
            {value ? "✓ Yes" : "✕ No"}
          </span>
        ),
      },
      {
        // leg1 is always this airport, leg2 the other end of the flight
        Header: "Assist At",
        accessor: "leg1Assistance",
        Cell: ({ row }) => {
          const other = isDepartures ? row.original.destination : row.original.origin;
          const pill = (label, value) => (
            <span className={"pbl-pill " + (value == "Requested" ? "pbl-pill-on" : "pbl-pill-off")}>
              {value == "Requested" ? "✓" : "✕"} {label}
            </span>
          );
          return (
            <div className="pbl-legs">
              {pill(hereCode || "Here", row.original.leg1Assistance)}
              {pill(other || "Other", row.original.leg2Assistance)}
            </div>
          );
        },
      },
      {
        Header: "Notes",
        accessor: "bio",
        Cell: ({ value }) =>
          value ? <div className="pbl-notes" title={value}>{value}</div> : <span className="pbl-muted">—</span>,
      },
      ...(isAirline ? [] : [{
        Header: "Review",
        accessor: "id",
        Cell: ({ value }) => {
          const status = reviewStatus[value];
          if (status?.status == "reviewed") {
            return (
              <div>
                <span className="pbl-pill pbl-pill-on">✓ Reviewed</span>
                {formatDay(status.at) && <span className="pbl-review-date">{formatDay(status.at)}</span>}
              </div>
            );
          }
          if (status?.status == "sent") {
            return <span className="pbl-pill pbl-pill-warn">Survey sent</span>;
          }
          return <span className="pbl-pill pbl-pill-off">Not reviewed</span>;
        },
      }]),
      {
        Header: "Created",
        accessor: "dateCreated",
        Cell: ({ value }) => <span className="pbl-mono pbl-muted">{value}</span>,
      },
    ];
  }, [type, reviewStatus, hereCode, isAirline]);

  const { getTableProps, getTableBodyProps, headerGroups, rows: tableRows, prepareRow } =
    useTable({ columns, data: rows });

  const loading = arrivalStatus == "loading" || departureStatus == "loading";

  return (
    <Container className="mt-4 pbl" style={{ paddingBottom: 50 }}>
      <Card
        shadow={true}
        decoration="top"
        decorationColor={type == "Departures" ? "blue" : "green"}
      >
        {/* Title + Departures / Arrivals Switcher */}
        <div className="pbl-header">
          <div>
            <TremorTitle>Booking List</TremorTitle>
            <div className="pbl-header-meta">
              <span>{type} for {date && !isNaN(new Date(date)) ? format(new Date(date), "EEEE d MMMM yyyy") : "the selected day"}</span>
              {!loading && <span className="pbl-count">{rows.length} shown</span>}
            </div>
          </div>
          <Toggle
            color="zinc"
            defaultValue={type}
            onValueChange={(value) => dispatch(setTable(value))}
          >
            <ToggleItem value={"Departures"} text="Departures" />
            <ToggleItem value={"Arrivals"} text="Arrivals" />
          </Toggle>
        </div>

        {/* Booking Table */}
        {loading ? (
          <Row className="justify-content-md-center mt-5">
            <CustomSpinner />
          </Row>
        ) : (
          <>
            <div className="pbl-scroll">
              <table className="pbl-table" {...getTableProps()}>
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {tableRows.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {!tableRows.length && (
                <div className="pbl-empty">No {type.toLowerCase()} booked for this day</div>
              )}
            </div>

            <PaginationClicker />
          </>
        )}
      </Card>
    </Container>
  );
};

export default BookingsList;
